import { EngineTheme } from '@websky/core/src/theme';
import cn from 'classnames';

import * as Button from './components/Button/Button.css';
import * as PromoLoader from './components/PromoLoader/PromoLoader.css';
import * as ResultsTheme from './components/Results/Results.css';
import * as ServiceBanner from './components/ServiceBanner/ServiceBanner.css';
import * as SearchForm from './components/SearchForm/SearchForm.css';
import * as BaggageService from './components/Baggage/Baggage.css';
import * as MealPage from './components/MealPage/MealPage.css';
import * as ServiceRecommendation from './components/ServiceRecommendation/ServiceRecommendation.css';
import * as Checkin from './components/Checkin/Checkin.css';
import * as Checkout from './components/Checkout/Checkout.css';
import * as BaggagePage from './components/BaggagePage/BaggagePage.css';
import * as MobileSummaryFlight from './components/MobileSummaryFlight/MobileSummaryFlight.css';
import * as MobileFlight from './components/MobileFlight/MobileFlight.css';
import * as QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import * as MobileSegmentInfo from './components/MobileSegmentInfo/MobileSegmentInfo.css';
import * as AdditionalService from './components/AdditionalService/AdditionalService.css';
import * as Amenities from './components/Amenities/Amenities.css';
import * as Modal from './components/Modal/Modal.css';
import * as PaidServiceCards from './components/PaidServiceCards/PaidServiceCards.css';
import * as CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import * as Passenger from './components/Passenger/Passenger.css';
import * as CheckoutOrderSummary from './components/CheckoutOrderSummary/CheckoutOrderSummary.css';
import * as ToggleableFlights from './components/Checkout/ToggleableFlights/ToggleableFlights.css';
import * as LoyaltyCard from './components/CheckoutAdditionalService/components/Loyalty/Loyalty.css';
import * as BusinessCard from './components/CheckoutAdditionalService/components/Business/Business.css';
import * as VisaForm from './components/VisaForm/VisaForm.css';
import * as PromoMessage from './components/PromoMessages/PromoMessages.css';
import * as Insurance from './components/Insurance/Insurance.css';
import * as SelectedPassenger from './components/SelectedPassenger/SelectedPassenger.css';
import * as SeatMap from './components/SeatMap/SeatMap.css';
import * as OrderCard from './components/OrderCard/OrderCard.css';
import * as FlightInfoCard from './components/FlightInfoCard/FlightInfoCard.css';
import * as AggregatorService from './components/CheckoutAdditionalService/components/AggregatorService/AggregatorService.css';
import * as ServiceAggregation from './components/ServiceAggregation/ServiceAggregation.css';
import FareConditions from './components/FareConditions/FareConditions.css';
import MobileSelectedFare from './components/MobileSelectedFare/MobileSelectedFare.css';
import * as FlightCard from './components/FlightCard/FlightCard.css';
import Refund from './components/Refund/Refund.css';
import Exchange from './components/Exchange/Exchange.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import PetPopup from './components/PetPopup/PetPopup.css';
import AdditionalServiceWrapper from './components/AdditionalServiceWrapper/AdditionalServiceWrapper.css';
import Currency from './components/SearchForm/Currency/Currency.css';
import SubsidySuggestPopup from './components/SubsidySuggestPopup/SubsidySuggestPopup.css';
import SubsidyRejectPopup from './components/SubsidyRejectPopup/SubsidyRejectPopup.css';
import ServiceWithSegment from './components/ServiceWithSegments/ServiceWithSegment.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import EveryPort from './components/EveryPort/EveryPort.css';
import Cart from './components/Cart/Cart.css';
import CheckoutStepbar from './components/Checkout/Stepbar/Stepbar.css';
import BaggageList from './components/BaggageList/BaggageList.css';
import LoyaltyConnect from './components/Loyalty/components/LoyaltyConnect/LoyaltyConnect.css';
import WarningModal from './components/WarningModal/WarningModal.css';
import SelectableSegment from './components/SelectableSegment/SelectableSegment.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import InsurancePopup from './components/InsurancePopup/InsurancePopup.css';
import VipServiceSelect from './components/VipServiceSelect/VipServiceSelect.css';
import InsuranceUpsale from './components/InsuranceUpsale/InsuranceUpsale.css';
import InsurancePage from './components/InsurancePage/InsurancePage.css';
import FareLock from './components/FareLock/FareLock.css';
import Meal from './components/Meal/Meal.css';
import Disclaimer from './components/Disclaimer/Disclaimer.css';
import LoginPage from './components/LoginPage/LoginPage.css';

const theme: EngineTheme = {
	SelectedPassenger: {
		SelectedPassenger: {
			loyalty__link: SelectedPassenger.loyalty__link
		}
	},
	CompareFares: {
		Cell: {
			image: CompareFares.image
		}
	},
	ServiceWithSegments: {
		ServiceWithSegments: {
			wrapper: ServiceWithSegment.wrapper
		}
	},
	SeatMap: {
		AirplaneStyles: {
			airplane__name: SeatMap.airplane__name,
			seatsDetails: SeatMap.airplane__seatsDetails
		},
		Passenger: {
			item: SeatMap.passenger,
			item_active: SeatMap.passenger_active,
			avatar: SeatMap.passenger__number,
			money: SeatMap.passenger__price,
			payload: SeatMap.passenger__payload,
			select: SeatMap.passengerMobile__seatSelect,
			select_selected: SeatMap.passengerMobile__seatSelect_selected,
			item_recommend: SeatMap.passenger_recommend,
			passengerName: SeatMap.passengerName
		},
		PassengersStyles: {
			recommend__wrapper: SeatMap.recommend__wrapper
		},
		SeatStyles: {
			seat_small: SeatMap.small,
			seat_combinedLeft: SeatMap.combined_left,
			seat_combinedRight: SeatMap.combined_right,
			seat: SeatMap.seat,
			number: SeatMap.seat__number,
			seat_recommend: SeatMap.seat_recommend,
			seat_recommendCurrent: SeatMap.seat_recommend_current,
			seat_business: SeatMap.seat_business,
			seat_preferred: SeatMap.seat_comfort,
			seat_unavailable: SeatMap.seat_notAvailable
		},
		SeatChoose: {
			seat: SeatMap.seatChoose__seat,
			preferred: SeatMap.seatChoose__preferred,
			business: SeatMap.seatChoose__business
		},
		SeatMapStyles: {
			row__serviceHeader: SeatMap.class__header,
			row__serviceHeader__wrapper: SeatMap.class__header__wrapper,
			row__seatWrapper_newClass: SeatMap.row__seatWrapper_newClass,
			row_otherClass: SeatMap.row_otherClass
		},
		SeatTooltipStyles: {
			tooltip: SeatMap.tooltip,
			tooltip_recommend: SeatMap.tooltip_recommend,
			info: SeatMap.info
		},
		SeatsInfoStyles: {
			header: SeatMap.seatsInfo__header,
			title: SeatMap.seatInfo__title,
			seat_business: SeatMap.seatInfo__business,
			classInfo: SeatMap.classInfo
		},
		SeatMapDisclaimerStyles: {
			disclaimer: SeatMap.disclaimer
		},
		SeatsRecommendPopup: {
			control: SeatMap.recomended_popup__control,
			control_free: SeatMap.recomended_popup__control_free,
			control_selected: SeatMap.recomended_popup__control_selected,
			price__wrapper: SeatMap.recomended_popup__price__wrapper,
			money: SeatMap.recomended_popup__money
		}
	},
	Checkin: {
		VisaForm: {
			header: VisaForm.header
		},
		CheckinErrorBoundary: {
			button: Checkin.errorBoundary__button,
			active: Checkin.errorBoundary__buttonActive
		},
		SelectSegmentsModal: {
			header: Checkin.selectSegmentsModal__header,
			button: Checkin.selectSegmentsModal__button
		}
	},
	VisaForm: {
		VisaForm: {
			visaWrapper: VisaForm.vizaWrapper
		}
	},
	Amenities: {
		Amenities: {
			amenities: Amenities.amenities
		}
	},
	Passenger: {
		PassengerStyles: {
			form__field_loyaltyCardHint: Passenger.form__field_loyaltyCardHint
		}
	},
	PassengerForm: {
		LoyaltyGroup: {
			loyalty__desc: Passenger.group_loyalty__desc
		}
	},
	Meal: {
		Meal: {
			meal: Meal.meal,
			price: cn(Meal.meal__price, Button.optionTextButton)
		}
	},
	ServiceRecommendation: {
		Base: {
			wrapper: ServiceRecommendation.wrapper,
			wrapper_mobileFullScreen: ServiceRecommendation.wrapper_mobileFullScreen,
			button: ServiceRecommendation.button,
			button_cancel: ServiceRecommendation.button_cancel
		},
		Meal: {
			price__money: ServiceRecommendation.meal__price
		},
		Seats: {
			header: ServiceRecommendation.seats__header,
			header_mobileFullScreen: ServiceRecommendation.seats__header_mobileFullScreen,
			summary__price: ServiceRecommendation.price
		},
		Table: {
			money: ServiceRecommendation.price,
			table: ServiceRecommendation.seats__table
		}
	},
	PromoMessage: {
		PromoMessage: {
			wrapper: PromoMessage.wrapper,
			link: PromoMessage.link,
			title: PromoMessage.title,
			content__text: PromoMessage.content__text
		}
	},
	PromoLoader: {
		PromoLoader: {
			promo: PromoLoader.promo,
			withoutContent: PromoLoader.withoutContent,
			promo__image: PromoLoader.promo__image,
			promo__content: PromoLoader.promo__content
		}
	},
	AdditionalServiceCard: {
		AdditionalServiceStyles: {
			logo__wrapper: AdditionalService.logo__wrapper
		}
	},
	Contacts: {
		ContactsStyles: {
			login__modal: Checkout.login__modal,
			header: Checkout.contacts__header,
			description__header: Checkout.contacts__descriptionHeader,
			footer__inner: Checkout.contacts__footerInner
		}
	},
	SearchFormDatepicker: {
		SearchFormDatepickerStyles: {
			dialog__activeDate: SearchForm.dialog__activeDate
		}
	},
	SearchForm: {
		PromoCode: {
			promoCode: SearchForm.promoCode
		},
		StartSearch: {
			startSearch: SearchForm.startSearh
		},
		Datepicker: {
			dates__to_focused: SearchForm.dates__to_focused,
			dates__back_focused: SearchForm.dates__back_focused
		},
		MultiCity: {
			multiCity: SearchForm.multiCity
		},
		Currency: {
			arrowIcon: Currency.arrowIcon,
			currency: Currency.currency,
			selector: Currency.selector,
			arrowIcon_flipped: Currency.arrowIcon_flipped
		},
		Passengers: {
			arrowIcon: SearchForm.passengers__arrowIcon,
			selector_focused: SearchForm.passengers__selectorFocused
		}
	},
	PromoCode: {
		PromoCodeForm: {
			button: ResultsTheme.promoCodeApplyButton
		}
	},
	QuickSearchForm: {
		QuickSearchForm: {
			promoCode: QuickSearchForm.promoCode,
			wrapper: QuickSearchForm.wrapper
		},
		Summary: {
			passengers: QuickSearchForm.passengers,
			route: QuickSearchForm.route,
			dates: QuickSearchForm.dates
		}
	},
	AdditionalServiceBanner: {
		AdditionalServiceBannerStyles: {
			baggageBanner: ServiceBanner.baggageBanner,
			seatBanner: ServiceBanner.seatMapBanner,
			mealBanner: ServiceBanner.mealBanner,
			image: ServiceBanner.banner__image,
			whiteLines: ServiceBanner.whiteLines,
			extrasBanner: ServiceBanner.extrasBanner,
			content: ServiceBanner.content,
			text: ServiceBanner.text,
			disclaimer: ServiceBanner.disclaimer,
			disclaimer__icon: ServiceBanner.disclaimer__icon
		}
	},
	RetrieveBooking: {
		RetrieveBooking: {
			container: Checkout.retrieveBooking
		}
	},
	Checkout: {
		PassengersToolbar: {
			root: Checkout.passengersToolbar__label
		},
		CheckoutStyles: {
			container: Checkout.container,
			detailsModal__header: Checkout.detailsModal__header,
			detailsModal__paper: Checkout.detailsModal__paper,
			detailsModal: Checkout.detailsModal
		},
		Insurance: {
			button: Button.additionalServiceButton
		},
		ThanksBanner: {
			wrapper: Checkout.thanksBanner
		},
		Upsale: {
			footer__button: Checkout.upsaleButton
		},
		Warning: {
			button: Checkout.warningButton
		},
		ServiceCardFooter: {
			footer__button: PaidServiceCards.footer__button,
			footer_selected: PaidServiceCards.footer_selected,
			footer__price: PaidServiceCards.footer__price
		},
		ToggleableFlights: {
			flights: ToggleableFlights.flights
		}
	},
	Aeroexpress: {
		Aeroexpress: {
			button: Button.additionalServiceButton
		}
	},
	Button: {
		Button: {
			button: Button.button,
			button_outline: Button.button_outline
		}
	},
	Results: {
		Results: {
			inner: ResultsTheme.inner,
			share: ResultsTheme.share
		},
		OtherDates: {
			container: ResultsTheme.otherDates
		},
		Disclaimer: {
			wrapper: ResultsTheme.outer__disclaimer
		},
		Sortings: {
			mobile__list_sorting: ResultsTheme.mobile__list_sorting,
			mobile__list_filter: ResultsTheme.mobile__list_filter,
			mobile__list__item: ResultsTheme.mobile__list__item,
			mobile__list__title: ResultsTheme.mobile__list__title,
			mobile__list__button: ResultsTheme.mobile__list__button
		},
		Calendar: {
			header: ResultsTheme.calendar__header,
			title__icon: ResultsTheme.calendar__title__icon,
			title__text: ResultsTheme.calendar__title__text,
			legNumber: ResultsTheme.calendar__legNumber,
			diagram: ResultsTheme.calendar__diagram
		}
	},
	FareGroup: {
		FareGroupGrid: {
			upgradeOffer: ResultsTheme.fareGroup_grid__upgradeOption,
			option: ResultsTheme.fareGroupGrid_option,
			not_available: ResultsTheme.fareGroupGrid_notAvailable,
			paid: ResultsTheme.fareGroupGrid_paid
		},
		FareGroup: {
			fareGroup_white: ResultsTheme.fareGroup_white,
			keyFeatures: ResultsTheme.fareGroup__keyFeatures,
			price: ResultsTheme.fareGroup__price,
			fareGroup: ResultsTheme.fareGroup,
			button: ResultsTheme.fareGroup__button,
			title: ResultsTheme.fareGroup__title,
			info: ResultsTheme.fareGroup__info,
			keyFeature: ResultsTheme.fareGroup__keyFeature,
			keyFeature_unavailable: ResultsTheme.keyFeature_unavailable,
			keyFeature_paid: ResultsTheme.keyFeature_paid,
			options: ResultsTheme.fareGroup__options,
			option: ResultsTheme.option,
			option_free: ResultsTheme.option_free,
			fareGroup_Business: ResultsTheme.fareGroup_Business,
			keyFeature__icon: ResultsTheme.keyFeature__icon,
			keyFeature__value: ResultsTheme.keyFeature__value,
			upgradeOffer: ResultsTheme.fareGroup__upgradeOption,
			upgradeOffer__link: ResultsTheme.fareGroup__upgradeOption__link,
			option__icon: ResultsTheme.fareGroup__optionIcon,
			option__title: ResultsTheme.fareGroup__optionTitle,
			option__value: ResultsTheme.fareGroup__optionValue
		},
		RecommendedBadge: {
			badge: ResultsTheme.recommendedBagde
		}
	},
	Location: {
		Location: {
			header: ResultsTheme.flightInfo__locationHeader
		}
	},
	FlightInfo: {},
	DesktopSummaryFlight: {
		Header: {
			header__cell: ResultsTheme.summaryFlight__cell,
			arrowIcon: ResultsTheme.summaryFlight__arrowIcon
		},
		SummaryFlight: {
			flight: ResultsTheme.summaryFlight,
			info: ResultsTheme.summaryFlight__info
		}
	},
	DesktopFlightInfo: {
		DesktopFlightInfo: {
			info: ResultsTheme.summaryFlight__info,
			button_default: ResultsTheme.summaryFlight__button_default
		},
		Segment: {
			aircraft__name__link: ResultsTheme.aircraft__name__link,
			aircraft__name: ResultsTheme.aircraft__name,
			flight: ResultsTheme.segment__flight,
			airline: ResultsTheme.segment__airline
		}
	},
	DesktopFlight: {
		Flight: {
			flight: ResultsTheme.desktop__flight,
			fareGroups: ResultsTheme.fareGroups
		},
		ModalContent: {
			paper: ResultsTheme.faresModalContent__paper,
			fareGroup_stub_business: ResultsTheme.fareGroup_stub_business,
			stubOptions: ResultsTheme.stubOptions,
			fareGroup__button: ResultsTheme.faresModalContent__button,
			fareGroup__button_business: ResultsTheme.faresModalContent__button_business,
			fareGroup__button_active: ResultsTheme.faresModalContent__button_active,
			close: ResultsTheme.faresModalContent__close,
			close_icon: ResultsTheme.faresModalContent__closeIcon,
			compareFaresLink: ResultsTheme.faresModalContent__compareFaresLink,
			scroll_up: ResultsTheme.faresModalContent__scrollUp
		},
		DesktopFlightPopup: {
			paper: ResultsTheme.desktopFlight__paper,
			closeIcon: ResultsTheme.roundedModal__close
		},
		Location: {
			terminal: ResultsTheme.desktopFlight_locationTerminal,
			date_icon: ResultsTheme.desktopFlight_locationDateIcon,
			weather_temp: ResultsTheme.desktopFlight_weatherTemp
		},
		SelectedFareGroup: {
			fareConditions__closeButton: ResultsTheme.fareConditions__closeButton
		}
	},
	FlightCard: {
		FlightCard: {
			airline: FlightCard.flightCard__airline,
			airline__logo: FlightCard.flightCard__airlineLogo,
			airline__number: FlightCard.flightCard__airlineNumber,
			aircraft__name: FlightCard.flightCard__aircraftName,
			footer: FlightCard.flightCard__footer,
			flight__block: FlightCard.flightCard__flightBlock,
			flight__title: FlightCard.flightCard__flightTitle,
			flight__value: FlightCard.flightCard__flightValue,
			info: FlightCard.flightCard__icon
		}
	},
	FlightInfoCard: {
		FlightInfoCardHeader: {
			header__text: FlightInfoCard.header__text,
			header__title: FlightInfoCard.header__title,
			header__textIcon: FlightInfoCard.header__textIcon
		},
		FlightInfoCard: {
			tabs__selectedTab: FlightInfoCard.tabs__selectedTab,
			tabs__tab: FlightInfoCard.tabs__tab,
			tabs__tab__header: FlightInfoCard.tabs__tab__header
		},

		FlightInfoCardTabs: {
			tabs__value: FlightInfoCard.tabs__value,
			tabs__segment: FlightInfoCard.tabs__segment,
			tabs__header: FlightInfoCard.tabs__header
		},
		FlightInfoCardPoint: {
			time: FlightInfoCard.time,
			airport: FlightInfoCard.airport
		},
		SegmentServices: {
			fareName: FlightInfoCard.fareName,
			service: FlightInfoCard.service
		}
	},
	ServiceAggregation: {
		ServiceAggregation: {
			header: ServiceAggregation.header
		},
		ServicesGroup: {
			direction: ServiceAggregation.direction,
			description: ServiceAggregation.description
		}
	},
	SelectedFare: {
		SelectedFare: {
			popup__paperScrollBody: ResultsTheme.selectedFare__paperScrollBody
		}
	},
	MobileSummaryFlight: {
		MobileSummaryFlight: {
			footer_flat: MobileSummaryFlight.footer_flat,
			footer__price_flat: MobileSummaryFlight.footer__price_flat,
			header: MobileSummaryFlight.header,
			leg: MobileSummaryFlight.leg,
			leg__date: MobileSummaryFlight.leg__date,
			closer: MobileSummaryFlight.closer,
			footer: MobileSummaryFlight.footer,
			footer__price: MobileSummaryFlight.footer__price
		}
	},
	MobileFlight: {
		FlightStyles: {
			flight_withAircraft: MobileFlight.flight_withAircraft,
			price: MobileFlight.price,
			price__money: MobileFlight.price__money
		},
		Info: {
			fareType_active: MobileFlight.fareType_active,
			fares__dots: MobileFlight.fares__dotsList
		}
	},
	BaggagePage: {
		BaggagePage: {
			items: BaggagePage.items,
			head: BaggagePage.head,
			passenger_active: BaggagePage.passenger_active,
			passenger: BaggagePage.passenger
		},
		MobileBaggageRules: {
			wrapper: BaggagePage.mobileBaggageRules__wrapper,
			notification: BaggagePage.mobileBaggageRules__notification,
			notificationText: BaggagePage.mobileBaggageRules__notificationText
		}
	},
	SpecialEquipment: {
		SpecialEquipment: {
			card__icon: BaggagePage.specialEquipment__icon
		}
	},
	BaggageService: {
		BaggageServiceStyles: {
			baggage_fullSizeItems: BaggageService.baggage_fullSizeItems,
			segment__value: BaggageService.segment__value,
			segment: BaggageService.segment,
			header__passenger: BaggageService.header__passenger,
			header__passenger__icon: BaggageService.header__passenger__icon,
			service: BaggageService.service,
			segment__direction: BaggageService.segment__direction,
			baggage_full: BaggageService.baggage_full,
			content: BaggageService.content,
			services: BaggageService.baggage__services,
			add__button: BaggageService.add__button,
			baggage: BaggageService.baggage,
			carryon: BaggageService.carryon,
			baggage__icon_notSelected: BaggageService.baggage__icon_notSelected,
			services__switcher: BaggageService.services__switcher,
			checkbox: BaggageService.baggage__checkbox,
			baggage__addButton: BaggageService.baggage__addButton,
			baggage__addButton_add: BaggageService.baggage__addButton_add,
			services_simple: BaggageService.baggage__services_simple
		},
		AdditionalStyles: {
			wrapper: BaggageService.additional__wrapper
		}
	},
	FlightPrice: {
		FlightPrice: {
			price__icon: ResultsTheme.flightPrice__icon,
			wrapper_economy: ResultsTheme.wrapper_economy,
			wrapper_business: ResultsTheme.wrapper_business,
			wrapper_active: ResultsTheme.wrapper_active
		}
	},
	MealPage: {
		MealPage: {
			header: MealPage.header
		}
	},
	Insurance: {
		InsuranceStyles: {
			dialog: Insurance.dialog,
			dialog__header: Insurance.header,
			controls: Insurance.controls,
			wrapper: Insurance.wrapper,
			rules: Insurance.rules,
			dialog__button_clear: Insurance.button__clear,
			dialog__button_done: Insurance.button__done
		},
		InsuranceCardStyles: {
			insurance__header: Insurance.insurance__header,
			insurance: Insurance.insurance,
			selected: Insurance.insurance_selected,
			insurance__money: Insurance.money,
			insurance__button: Insurance.insurance__button,
			insurance__button_selected: Insurance.insurance__button_selected
		},
		MobileScreenStyles: {
			header: Insurance.mobileHeader
		}
	},
	Counter: {
		Counter: {
			button_inc: ResultsTheme.counter_inc,
			button_dec: ResultsTheme.counter_dec,
			button: ResultsTheme.counter__button
		}
	},
	MobileSegmentInfo: {
		MobileSegmentInfo: {
			statistics: MobileSegmentInfo.statistics,
			segment_filled: MobileSegmentInfo.segment_filled,
			date: MobileSegmentInfo.date,
			date_nextDayArrival: MobileSegmentInfo.date_nextDayArrival,
			details__logo: MobileSegmentInfo.logo,
			aircraft: MobileSegmentInfo.aircraft,
			aircraft__features__moreInfo: MobileSegmentInfo.moreInfo
		},
		MobileSegmentFlat: {
			icons: MobileSegmentInfo.icons,
			city: MobileSegmentInfo.city
		}
	},
	Modal: {
		Modal: {
			closeIcon: Modal.closeIcon,
			modal_rounded: Modal.modal_rounded,
			modal: Modal.modal,
			closeIcon_mobileFullScreen: Modal.closeIcon_mobileFullScreen,
			scrollBody: Modal.scrollBody
		}
	},
	StatusMessage: {
		StatusMessage: {
			statusMessage_success: Checkin.statusMessage_success
		}
	},
	CheckoutAdditionalService: {
		CheckoutAdditionalService: {
			add: CheckoutAdditionalService.add,
			list__cities: CheckoutAdditionalService.city
		},
		Business: {
			business: AggregatorService.aggregator_business,
			paper: BusinessCard.paper,
			header: BusinessCard.header,
			serviceSelect: BusinessCard.serviceSelect,
			serviceSelect_aggregator: BusinessCard.serviceSelect_aggregator
		},
		Loyalty: {
			loyalty: cn(LoyaltyCard.loyalty, AggregatorService.aggregator_loyalty),
			loyalty_aggregator: AggregatorService.loyalty_aggregator,
			loyalty__paper: LoyaltyCard.loyalty__paper,
			loyalty__awardedInfo: LoyaltyCard.loyalty__awardedInfo
		},
		InsuranceUpsale: {
			content: InsuranceUpsale.content,
			container: InsuranceUpsale.container,
			button: InsuranceUpsale.button,
			change: InsuranceUpsale.change,
			loading: InsuranceUpsale.loading
		},
		AggregatorService: {
			container: AggregatorService.container,
			container_active: AggregatorService.container_active,
			add: AggregatorService.add,
			header: AggregatorService.header,
			totalPrice: AggregatorService.totalPrice,
			cover: AggregatorService.cover,
			icons: AggregatorService.icons,
			button: AggregatorService.button,
			button_add: AggregatorService.button_add
		},
		Animal: {
			container: cn(AggregatorService.aggregator_animal)
		},
		BaggageDelivery: {
			baggageDelivery: cn(AggregatorService.aggregator_baggageDelivery)
		},
		EveryPortLounge: {
			button_passenger: EveryPort.button_passenger,
			button_selected: EveryPort.button_selected
		},
		PetPopup: {
			content_aggregator: PetPopup.content_aggregator,
			header: PetPopup.header
		}
	},
	EveryPortCard: {
		EveryPortCard: {
			button: EveryPort.button,
			button_selected: EveryPort.button_selected
		}
	},
	CheckoutOrderSummary: {
		OrderSummary: {
			wrapper: CheckoutOrderSummary.wrapper,
			price: CheckoutOrderSummary.price,
			details: CheckoutOrderSummary.details
		}
	},
	OrderCard: {
		OrderCard: {
			container: OrderCard.orderCard_container,
			type_review: OrderCard.orderCard_typeReview,
			type_account: OrderCard.type_account,
			preview: OrderCard.preview
		},
		CommonItem: {
			root: OrderCard.commonItem_root,
			payload: OrderCard.commonItem_payload,
			review: OrderCard.commonItem_review
		},
		PaymentStatus: {
			root: OrderCard.paymentStatus_root,
			account: OrderCard.paymentStatus_account
		},
		OrderStatus: {
			root: OrderCard.orderStatus_root,
			type_review: OrderCard.orderStatus_typeReview,
			confirmed: OrderCard.orderStatus_confirmed,
			transactions: OrderCard.orderStatus_transactions
		},
		OrderBooking: {
			root: OrderCard.orderBooking_root,
			type_review: OrderCard.orderBooking_typeReview,
			orderCode: OrderCard.orderBooking_orderCode
		},
		OrderPassengers: {
			control: OrderCard.orderPassengers_control
		},
		OrderTickets: {
			link: OrderCard.orderTickets_link
		},
		OrderCardControls: {
			button_checkin: OrderCard.orderCardControls_buttonCheckin
		},
		OrderChange: {
			button: OrderCard.orderChange__button
		}
	},
	Notification: {
		Notification: {
			wrapper: cn(
				ResultsTheme.notification_wrapper,
				SubsidySuggestPopup.notification,
				SubsidyRejectPopup.notification
			),
			text: cn(ResultsTheme.notification_text, SubsidyRejectPopup.text),
			icon: cn(SubsidySuggestPopup.icon, SubsidyRejectPopup.icon)
		}
	},
	FfpInfoNotice: {
		FfpInfoNotice: {
			wrapper: ResultsTheme.ffpInfoNotice_wrapper
		}
	},
	FareConditions: {
		FareConditions: {
			paperRoot: cn(FareConditions.paperRoot, ResultsTheme.fareConditions_paperRoot),
			fareConditionsContent: cn(FareConditions.fareConditionsContent, ResultsTheme.fareConditions__content)
		}
	},
	MobileSelectedFare: {
		MobileSelectedFareStyles: {
			dialog__header: MobileSelectedFare.dialog__header
		}
	},
	Refund: {
		Price: {
			total: Refund.price__total,
			row: Refund.price__row
		},
		StepTitle: {
			icon: Refund.stepTitle__icon
		},
		MobileStep: {
			header: Refund.mobileStep__header
		}
	},
	Exchange: {
		SearchFlights: {
			leg: Exchange.searchFlights__leg
		},
		CreateRequest: {
			row: Exchange.createRequest__row
		}
	},
	DesktopFlightRoute: {
		SegmentStyles: {
			totalDuration: DesktopFlightRoute.segment__totalDuration,
			planeInfo: DesktopFlightRoute.segment__planeInfo,
			aircraft: DesktopFlightRoute.segment__aircraft,
			amenities: DesktopFlightRoute.segment__amenities
		}
	},
	PetPopup: {
		PetPopup: {
			disclaimer: PetPopup.petPopup__disclaimer,
			checkbox__root: PetPopup.petPopup__checkbox,
			checkbox__checked: PetPopup.petPopup__checkboxChecked,
			passenger__price: PetPopup.petPopup__passengerPrice,
			button__clear: PetPopup.petPopup__buttonClear
		}
	},
	AdditionalServiceWrapper: {
		AdditionalServiceWrapper: {
			button: AdditionalServiceWrapper.additionalServiceWrapper__button
		}
	},
	SubsidySuggestPopup: {
		SubsidySuggestPopup: {
			container: SubsidySuggestPopup.container,
			header__text: SubsidySuggestPopup.header__text,
			description: SubsidySuggestPopup.description,
			info__icon: SubsidySuggestPopup.info__icon,
			decrease: SubsidySuggestPopup.decrease,
			increase: SubsidySuggestPopup.increase,
			counter: SubsidySuggestPopup.counter,
			passengers: SubsidySuggestPopup.passengers,
			item: SubsidySuggestPopup.item,
			notification: SubsidySuggestPopup.notification,
			newSearch: SubsidySuggestPopup.newSearch,
			continueButton: SubsidySuggestPopup.continueButton
		}
	},
	SubsidyRejectPopup: {
		SubsidyRejectPopup: {
			container: SubsidyRejectPopup.container,
			header__text: SubsidyRejectPopup.header__text,
			flight: SubsidyRejectPopup.flight,
			flight__direction: SubsidyRejectPopup.flight__direction,
			passenger: SubsidyRejectPopup.passenger,
			notification: SubsidyRejectPopup.notification,
			notification__title: SubsidyRejectPopup.notification__title,
			newSearch: SubsidyRejectPopup.newSearch,
			continueButton: SubsidyRejectPopup.continueButton
		}
	},
	PaymentForm: {
		PaymentForm: {
			cards: PaymentForm.cards,
			card: PaymentForm.card,
			cards_header: PaymentForm.cards_header,
			gateways_hidden: PaymentForm.gateways_hidden,
			gateways: PaymentForm.gateways,
			paylate: PaymentForm.paylate,
			summaryGroup_priceParts: PaymentForm.summaryGroup_priceParts,
			summaryGroup_total: PaymentForm.summaryGroup_total,
			details__total: PaymentForm.details__total,
			summaryGroup_order: PaymentForm.summaryGroup_order,
			details__button: PaymentForm.details__button
		},
		Gateway: {
			selector: PaymentForm.gateway__selector,
			header__arrow: PaymentForm.header__arrow,
			arrow: PaymentForm.gateway__arrow
		}
	},
	ServiceSummary: {
		ServiceSummaryOption: {
			option__included: Cart.serviceSummary__included,
			option__price_money: cn(Cart.serviceSummary__option__price, InsuranceUpsale.option__price),
			option__icon: Cart.serviceSummary__option__icon,
			header: Cart.serviceSummary__option__header
		},
		ServiceSummary: {
			wrapper: Cart.serviceSummary__wrapper,
			header__number: Cart.serviceSummary__header__number
		},
		ServiceSummaryNotification: {
			wrapper: cn(ResultsTheme.serviceSummaryNotification)
		}
	},
	BaggageList: {
		BaggageList: {
			add: BaggageList.add
		}
	},
	Loyalty: {
		LoyaltyConnect: {
			buttons__wrapper: LoyaltyConnect.buttons__wrapper
		}
	},
	WarningModal: {
		WarningModal: {
			content: WarningModal.content,
			buttons: WarningModal.buttons,
			closeButton: WarningModal.closeButton
		}
	},
	SelectableSegment: {
		SelectableSegmentDesktop: {
			airplane: SelectableSegment.selectableSegmentDesktop__airplane
		},
		SelectableSegmentMobile: {
			planeIcon: SelectableSegment.selectableSegmentMobile__airplane
		}
	},
	InsurancePopup: {
		InsurancePopup: {
			header: InsurancePopup.header,
			content: InsurancePopup.content,
			footer: InsurancePopup.footer
		},
		InsuranceCard: {
			header: InsurancePopup.insuranceCard__header,
			wrapper: InsurancePopup.insuranceCard__wrapper,
			active: InsurancePopup.insuranceCard__active,
			header_price: InsurancePopup.insuranceCard__headerPrice,
			content: InsurancePopup.insuranceCard__content
		}
	},
	InsurancePage: {
		InsuranceUpsaleModal: {
			root: InsurancePage.insuranceUpsaleModal__root
		},
		SelectForm: {
			form: InsurancePage.form,
			form_error: InsurancePage.form_error,
			root: InsurancePage.root
		}
	},
	AdditionalServices: {
		Insurance: {
			paper: InsurancePopup.additionalServices__paper
		}
	},
	VipServiceSelect: {
		VipServiceSelect: {
			switch__container_disable: VipServiceSelect.switch__container_disable
		}
	},
	FareLock: {
		DescriptionBlock: {
			description: FareLock.description,
			warning: FareLock.warning
		},
		SwitchBlock: {
			root: FareLock.root
		}
	},
	Baggage: {
		Baggage: {
			root: BaggageService.baggage__root,
			selected: BaggageService.baggage__selected,
			icon: BaggageService.baggage__icon
		},
		BaggageIcon: {
			carry_on: BaggageService.baggageIcon__carry_on,
			small: BaggageService.baggageIcon__small,
			large: BaggageService.baggageIcon__large,
			wrapper: BaggageService.baggageIcon__wrapper,
			size: BaggageService.baggageIcon__size
		}
	}
};

export default theme;
